import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'en_EG',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: false,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: false,
  },
  'f1967b97-c95f-4a6b-b723-59f24b1f3e3d',
  ''
);
